import { returnData } from 'services/api-client/client';
import type { HttpClient } from 'services/api-client/client';
import type { SharedApi } from '@env0/shared/api';
import type { AxiosResponse } from 'axios';

// the user waits on this call to log out; a timed-out call is not retried
const LOGOUT_TIMEOUT_MS = 5000;

export default (client: HttpClient) => ({
  uploadScreenshot: (image: string) => {
    return client
      .post<SharedApi.UploadScreenshot.Request.Body, AxiosResponse<SharedApi.UploadScreenshot.Response>>(
        `/screenshot/upload`,
        { image }
      )
      .then(returnData);
  },
  // retried like a read: ending the tokens twice changes nothing
  logout: () =>
    client.post<void>('/auth/logout', undefined, {
      retryAsRead: true,
      hideNotification: true,
      timeout: LOGOUT_TIMEOUT_MS
    })
});
